import * as React from 'react';
import RibbonButton from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { ColorPicker, textColors } from 'owa-color-picker';
import { setTextColor } from 'roosterjs-editor-api';

const textColor: RibbonButton = {
    key: 'textColor',
    title: () => strings.textColor,
    imageSrc: require('../svg/textcolor.svg'),
    createDropDownCallback: (target, plugin, dismiss, logUsage) => (
        <ColorPicker
            menuTargetElement={target}
            onDismissMenu={dismiss}
            colors={textColors.get()}
            onSelectColor={color => {
                setTextColor(plugin.getEditor(), color.code);
                logUsage('setTextColor', color.code);
            }}
            shouldFocusOnMount={true}
            selectedColor={plugin.getFormatState().textColor}
        />
    ),
};

export default textColor;
